import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
export const variantDto = z.object({
    id: uuid,
    externalId: z.string().nullable(),
    productExternalId: z.string().nullable(),
    sku: z.string(),
    title: z.string(),
    productTitle: z.string(),
    productNumber: z.string().nullable(),
    imageUrl: z.string().nullable(),
    active: z.boolean(),
    weightG: z.number().int().nullable(),
    lengthMm: z.number().int().nullable(),
    widthMm: z.number().int().nullable(),
    heightMm: z.number().int().nullable(),
    hsCode: z.string().nullable(),
    countryOfOrigin: z.string().nullable(),
    customsValueMinor: z.number().int().nullable(),
    syncedAt: isoDateTime.nullable(),
});
export const variantQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
    q: z.string().trim().max(200).optional(),
    active: z.coerce.boolean().optional(),
});
export const updateVariantRequest = z.object({
    weightG: z.number().int().min(0).nullable().optional(),
    lengthMm: z.number().int().min(0).nullable().optional(),
    widthMm: z.number().int().min(0).nullable().optional(),
    heightMm: z.number().int().min(0).nullable().optional(),
    hsCode: z.string().max(20).nullable().optional(),
    countryOfOrigin: z.string().length(2).nullable().optional(),
    customsValueMinor: z.number().int().min(0).nullable().optional(),
});
/** A `SAM;…` variant whose components could not all be found, so it is not a bundle yet. */
export const unresolvedBundleDto = z.object({
    variantId: uuid,
    productId: uuid,
    productTitle: z.string(),
    variantTitle: z.string(),
    sku: z.string(),
    active: z.boolean(),
    /** Lines on orders in new, released, in_progress or partially_shipped. */
    openOrderLines: z.number().int(),
    /** Parts of the SKU that are neither a variant nor a Navision item (case-insensitive). */
    unknown: z.array(z.string()),
});
export const rebuildBundlesResultDto = z.object({
    checked: z.number().int(),
    built: z.number().int(),
    unresolved: z.array(z.object({ sku: z.string(), missing: z.array(z.string()) })),
});
//# sourceMappingURL=catalogue.js.map